import React from 'react';
import FollowerRadarCTA from './FollowerRadarCTA';
import CallServicesCTA from './CallServicesCTA';

// 첫 화면의 '다른 서비스' 소개 묶음 (2026-10-22 — HomePage 800줄 규칙 때문에 한 자리로 묶음)
const OtherServiceCTAs: React.FC = () => (
    <>
        {/* 팔로워 레이더 유입 CTA (인스타 전문 서비스라 맨 위) */}
        <FollowerRadarCTA />

        {/* 블랭킷 전화 상담 소개 — 대표 2026-10-22 '전화로 받는 서비스들을 소셜데이터랩 안에' */}
        <CallServicesCTA />

        {/* 과학적 안면 분석 CTA(MASK LAB) — 2026-10-22 대표 지시로 노출 중단("어차피 우리 그 서비스 안 하고 있는 거야").
            컴포넌트(FaceAnalysisCTA.tsx)는 그대로 남겨 둠 — import와 아래 한 줄만 되살리면 복구된다. */}
        {/* <FaceAnalysisCTA /> */}
    </>
);

export default OtherServiceCTAs;
